"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLineFilterPeriodTimesComparison = void 0;
const react_1 = require("react");
const dayjs_1 = __importDefault(require("dayjs"));
const useInterval_1 = require("./useInterval");
const TIMES_COMPARISON_INTERVAL = 2000;
const useLineFilterPeriodTimesComparison = ({ filterPeriod, callback, selectedPeriodValue, }) => {
    const compareTimes = (0, react_1.useCallback)(() => {
        const { applicationTime } = filterPeriod;
        if (applicationTime === null || applicationTime === void 0 ? void 0 : applicationTime.length) {
            const isSameDate = (0, dayjs_1.default)().isSame(applicationTime, 'minute');
            if (!isSameDate && selectedPeriodValue) {
                callback();
            }
        }
    }, [callback, filterPeriod, selectedPeriodValue]);
    (0, useInterval_1.useInterval)(compareTimes, TIMES_COMPARISON_INTERVAL, true);
    return null;
};
exports.useLineFilterPeriodTimesComparison = useLineFilterPeriodTimesComparison;
//# sourceMappingURL=useLineFilterPeriodTimesComparison.js.map